import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../utils';

import { inputVariants } from './inputVariants';

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'id'>,
    VariantProps<typeof inputVariants> {
  id: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant, id, ...props }, ref) => {
    return (
      <input
        type={type}
        id={id}
        data-testid={id}
        className={cn(inputVariants({ variant }), className)}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
